module.exports = __webpack_public_path__ + "media/honey-icons/icon-link-broken-97532a96.svg";